import formatNumberWithSpaces from "./formatNumberWithSpaces";

function roundDownToTwoDecimals(number) {
  return +((number * 100) / 100).toFixed(2);
}

export default function calculateRate(rate, percent, needFormat = true) {
  const adjustedRate = rate * (1 + percent);

  const roundedRate = roundDownToTwoDecimals(adjustedRate);

  if (needFormat) {
    return `${formatNumberWithSpaces(roundedRate.toFixed(2))}`;
  } else {
    return roundedRate.toFixed(2);
  }
}
